import React from 'react';
import { isDirty, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { onClickCreateModifier } from 'actions/businessLibrary/modifier';
import { askConfirmAction } from 'actions/confirm-action';
import MenuTitle from 'components/MenuTitle';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    return (
      <div className={`row ${styles.wrapper}`}>
        <MenuTitle menuTitle="Modifiers" />
        <div className="col-sm-8 hidden-xs col-md-6 action-modifier">
          <span className="pull-right">
            <button
              className="btn btn-primary"
              onClick={this.onClickCreateModifier}
            >
              Create Modifier
            </button>
          </span>
        </div>
      </div>
    );
  }

  onClickCreateModifier = () => {
    const {
      askConfirmAction,
      onClickCreateModifier,
      isDirtyModifier,
    } = this.props;
    if (isDirtyModifier) {
      askConfirmAction(onClickCreateModifier());
    } else {
      onClickCreateModifier();
    }
  };
}

function mapStateToProps(state) {
  return {
    isDirtyModifier: isDirty('modifierHub')(state),
    searchValue: getFormValues('search')(state),
  };
}

const mapDispatchToProps = {
  askConfirmAction,
  onClickCreateModifier,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionBar);
